import { CommonModule, NgFor, NgSwitch } from '@angular/common'
import { Component, inject } from '@angular/core'
import { HasPermissionDirective } from '../../../directives/has-permission.directive'
import { Store } from '@ngrx/store'
import { selectUserPermissions } from '../../../store/auth/auth.selectors'
import { take } from 'rxjs'
import { TaxSlabsComponent } from '../tax-slabs/tax-slabs.component'
import { TaxRulesComponent } from '../tax-rules/tax-rules.component'

@Component({
  selector: 'app-tax-wrapper',
  imports: [
    NgFor,
    NgSwitch,
    CommonModule,
    HasPermissionDirective,
    TaxSlabsComponent,
    TaxRulesComponent
  ],
  templateUrl: './tax-wrapper.component.html',
  styleUrl: './tax-wrapper.component.scss'
})
export class TaxWrapperComponent {
  private store = inject(Store)
  tabs: string[] = ['Tax Slabs', 'Tax Rules']

  //---State---//
  activeChild = '' // Initially empty
  permissionsMap = new Map<string, Record<string, string[]>>()

  constructor() {
    this.store
      .select(selectUserPermissions)
      .pipe(take(1))
      .subscribe(userPermissions => {
        const permissions = userPermissions as Record<string, string[]>

        // Find the first tab the user has 'view' permission for
        const firstAccessibleTab = this.tabs.find(tab => {
          const tabKey = this.getTabKey(tab)
          return permissions[tabKey]?.includes('view')
        })

        // Set the first accessible tab as activeChild, otherwise default to first tab
        this.activeChild = firstAccessibleTab ?? this.tabs[0]
      })
  }

  renderChild(tab: string) {
    this.activeChild = tab
  }

  //Creates permissions object
  makePermissions(tab: string, permissions: string[]): Record<string, string[]> {
    if (!this.permissionsMap.has(tab)) {
      const key = this.getTabKey(tab)
      this.permissionsMap.set(tab, { [key]: [...permissions] })
    }
    return this.permissionsMap.get(tab) ?? {}
  }

  private getTabKey(tab: string): string {
    return tab
      .replace(/\s(.)/g, (match, group1) => group1.toUpperCase()) // Capitalize after space
      .replace(/\s/g, '') // Remove spaces
      .replace(/^(.)/, match => match.toLowerCase()) // Lowercase first letter
  }
}
